var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _g2, _path16, _path17, _path18, _g3, _path19, _path20, _g4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 249,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M122.666 124.348 99.389 86.225C89 69.205 63.653 56.49 44.042 58.454c-7.525.753-12.88 3.542-15.08 7.845-2.283 4.469-1.218 10.91 2.909 17.666l23.276 38.123-18.437 10.866L13.434 94.83C5.446 81.75 4.1 67.9 9.742 56.835 15.27 46 26.976 38.928 41.862 37.438c27.907-2.794 61.278 13.863 75.965 37.921l23.276 38.124-18.437 10.865Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M21.281 94.434c-6.918-10.818-6.651-23.92-10.969-27.953-1.222 8.848 1.076 18.607 6.795 27.982l7.51 12.303c.99-1.724 1.186-5.26-3.336-12.332Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M121.5 106.756c-6.65-10.436-14.763-22.119-12.58-23.32 2.182-1.202 10.067 11.09 18.798 22.697l-6.218.623Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m100.924 84.734 22.684 35.902 2.503-1.869-26.645-42.121c-6.001-9.484-12.47-23.059-37.716-29.325-30.39-7.54-45.407 10.97-35.766 26.119-1.568-7.545 4.022-15.697 16.41-16.937 20.581-2.06 46.048 8.472 58.529 28.224l.001.007Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m79.07 128.326-11.264-16.194-26.056 2.609c-10.868 1.088-23.934 9.735-29.038 19.225-2.459 4.568-2.632 8.525-.95 11.279l51.258 83.948 64.247-27.195-48.19-73.673-.007.001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m217.548 192.96-18.557 34.494c-1.317 2.447-4.082 4.137-8.023 4.532l18.558-34.495c3.941-.394 6.705-2.091 8.022-4.531Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m209.525 197.489-18.558 34.494-73.023 7.311 18.564-34.495 73.017-7.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "m136.509 204.799-18.565 34.495-17.447-8.727 18.558-34.494 17.454 8.726Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m119.055 196.073-18.558 34.494-26.056 2.608c-10.869 1.089-15.578-5.78-10.474-15.269 5.105-9.483 18.17-18.137 29.038-19.225l26.057-2.609-.007.001Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m209.525 197.489-73.024 7.311-17.446-8.727-26.056 2.609c-10.869 1.088-23.934 9.736-29.038 19.225-5.105 9.483-.389 16.357 10.473 15.27l26.056-2.609 17.447 8.727 73.024-7.311c3.941-.395 6.705-2.091 8.023-4.531l18.557-34.494c-1.316 2.446-4.081 4.136-8.022 4.531l.006-.001Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M94.426 109.467 75.87 143.961l-52.684 5.274c-10.868 1.089-15.577-5.78-10.473-15.269 5.104-9.489 18.17-18.137 29.037-19.225l52.684-5.275-.007.001Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 21,
    height: 13,
    x: 68,
    y: 160,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m88.543 160.493-17.867 11c-.68.416-1.509.663-2.49.727l17.868-10.999c.98-.065 1.81-.311 2.49-.728Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.543 160.494-17.867 10.999a4.765 4.765 0 0 1-1.117.495l17.868-11a4.444 4.444 0 0 0 1.116-.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.427 160.988-17.868 10.999a6.464 6.464 0 0 1-1.372.24l17.868-10.999a6.044 6.044 0 0 0 1.372-.24Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m88.544 160.494-17.868 10.999c-.68.417-1.509.663-2.489.727l17.868-10.999c.98-.064 1.809-.311 2.489-.727Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m70.28 136.792-17.874 11-.113-7.247 17.868-10.999.119 7.246Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 22,
    height: 19,
    x: 59,
    y: 147,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m80.06 154.419-17.868 10.999c.542-.334.832-1.026.818-2.103-.04-2.249-1.454-4.101-3.734-5.109l17.867-10.999c2.288 1.014 3.702 2.859 3.734 5.109.014 1.07-.268 1.768-.817 2.103Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.878 152.317a5.172 5.172 0 0 0-.309-1.704 5.111 5.111 0 0 0-.484-.982L62.217 160.63c.2.308.359.64.485.983.125.342.21.695.263 1.066.022.209.043.419.045.637.014 1.071-.268 1.768-.817 2.103L80.06 154.42c.543-.335.832-1.026.818-2.103Zm-3.595-5.041-17.868 10.999c-.05-.022-.095-.045-.146-.067l17.868-10.999c.05.022.102.044.146.067Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m80.06 154.418-17.868 11c.542-.335.832-1.026.818-2.103-.04-2.25-1.455-4.102-3.734-5.109l17.867-10.999c2.287 1.013 3.702 2.858 3.734 5.108.014 1.071-.268 1.768-.817 2.103Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M60.738 132.573 42.87 143.572l-.112-7.247 17.868-10.999.112 7.247Zm16.544 14.701-11.043-4.889-17.868 11 11.05 4.888c1.213.568 2.173 1.373 2.789 2.356l17.867-10.999c-.623-.982-1.575-1.788-2.788-2.356h-.007Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 22,
    height: 19,
    x: 60,
    y: 161,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m81.005 168.896-17.867 10.999c.555-.342.85-1.054.832-2.165-.036-2.352-1.5-4.274-3.918-5.343l17.867-11c2.419 1.069 3.883 2.991 3.918 5.343.018 1.112-.276 1.824-.832 2.166Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.837 166.73a5.537 5.537 0 0 0-.049-.671 5.62 5.62 0 0 0-.275-1.113 5.333 5.333 0 0 0-.501-1.015l-17.868 11a5.29 5.29 0 0 1 .826 2.798c.018 1.111-.277 1.823-.832 2.166l17.867-10.999c.556-.343.85-1.055.832-2.166Zm-3.757-5.27-17.868 10.999c-.05-.022-.103-.051-.16-.073l17.867-10.999c.051.022.11.05.16.073Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m81.005 168.895-17.867 11c.555-.343.85-1.055.832-2.166-.036-2.352-1.5-4.274-3.919-5.343l17.868-10.999c2.418 1.068 3.883 2.991 3.918 5.343.018 1.111-.276 1.823-.832 2.165Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    width: 28,
    height: 14,
    x: 62,
    y: 176,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m89.529 177.564-17.867 10.999c-2.013 1.24-5.274 1.02-9.565-.879l17.868-10.999c4.29 1.899 7.545 2.119 9.564.879Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m89.53 177.564-17.868 11a4.898 4.898 0 0 1-1.163.512l17.867-10.999c.425-.125.81-.3 1.163-.513Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m89.529 177.564-17.867 10.999c-2.013 1.24-5.274 1.02-9.565-.879l17.868-10.999c4.29 1.899 7.545 2.119 9.564.879Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m77.919 161.384-11.459-5.072-17.867 10.999 11.458 5.073.958-.417-.797.489c1.285.595 2.283 1.445 2.931 2.465l17.868-10.999c-.648-1.021-1.647-1.87-2.932-2.465"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m77.919 161.384-11.459-5.072-17.867 10.999 11.458 5.073.958-.417-.797.489c1.285.595 2.283 1.445 2.931 2.465l17.868-10.999c-.648-1.021-1.647-1.87-2.932-2.465"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M85.398 178.278c-1.56-.164-3.38-.685-5.434-1.599l-3.737-1.654-17.868 10.999 3.737 1.654c2.054.907 3.875 1.435 5.435 1.6 1.13.119 2.124.046 2.967-.202l17.868-10.999c-.85.249-1.844.321-2.968.201Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M56.179 137.932 38.31 148.931l-6.133-2.711 17.874-11 6.127 2.712Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m50.052 135.22-17.874 11-.118-7.431 17.875-11 .117 7.431Zm20.793 37.431L52.977 183.65l-4.159-1.836 17.868-11 4.159 1.837Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m76.335 182.163-17.867 10.999-5.384-2.383 17.874-11 5.377 2.384Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m70.959 179.779-17.875 11-.107-7.131 17.867-10.999.115 7.13Zm-14.451-20.846-17.867 11-.33-21.003 17.867-11 .33 21.003Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m66.8 177.944-17.868 10.999-5.383-2.383 17.867-10.999 5.384 2.383Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m61.416 175.559-17.867 11-.114-7.131 17.874-11 .107 7.131Zm-10.917-11.913-17.867 10.999-.124-7.422 17.874-11 .117 7.423Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "m56.625 166.358-6.126-2.712-17.868 11 6.127 2.711 4.677 2.072 17.874-11-4.684-2.071Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M86.055 161.226c3.705 3.016 5.754 6.764 5.819 10.868.099 6.046-4.275 7.972-11.909 4.592l-3.737-1.654.114 7.131-5.383-2.384-.114-7.13-4.152-1.837.114 7.13-5.384-2.383-.114-7.131-4.677-2.071-6.126-2.712-.117-7.424 6.127 2.712-.33-21.003-6.127-2.712-.117-7.43 6.126 2.712 4.677 2.071-.113-7.246 5.384 2.383.112 7.247 4.152 1.837-.112-7.246 5.383 2.383.113 7.246 2.987 1.326c7.59 3.357 11.984 9.069 12.082 14.965.053 3.532-1.578 5.559-4.677 5.767v-.007Zm-8.019 7.385c2.418 1.069 3.843.53 3.808-1.883-.035-2.352-1.5-4.275-3.918-5.343l-11.459-5.073.117 7.225 11.46 5.073m-11.791-26.226.11 6.967 10.898 4.822c2.288 1.013 3.661.453 3.63-1.852-.038-2.249-1.453-4.101-3.733-5.109L66.26 142.39"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M78.036 168.611c2.418 1.069 3.843.53 3.808-1.883-.035-2.352-1.5-4.275-3.918-5.343l-11.459-5.073.117 7.225 11.46 5.073m-11.791-26.226.11 6.967 10.898 4.822c2.288 1.013 3.661.453 3.63-1.852-.038-2.249-1.453-4.101-3.733-5.109L66.26 142.39m19.795 18.836c3.704 3.016 5.754 6.764 5.819 10.868.099 6.046-4.275 7.972-11.909 4.592l-3.737-1.654.114 7.131-5.383-2.384-.114-7.13-4.152-1.837.114 7.13-5.384-2.383-.114-7.131-4.677-2.071-6.126-2.712-.117-7.424 6.127 2.712-.33-21.003-6.127-2.712-.117-7.43 6.126 2.712 4.677 2.071-.113-7.246 5.384 2.383.112 7.247 4.152 1.837-.112-7.246 5.383 2.383.113 7.246 2.987 1.326c7.59 3.357 11.984 9.069 12.082 14.965.053 3.532-1.578 5.559-4.677 5.767v-.007Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "M90.525 224.097c9.058-5.315 14.109-13.394 11.282-18.045-2.828-4.65-12.463-4.112-21.521 1.203-9.058 5.315-14.11 13.394-11.282 18.045 2.828 4.65 12.463 4.112 21.521-1.203Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1B1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M97.178 213.843c-1.293 2.752-4.161 5.715-8.04 7.988-6.61 3.878-13.638 4.267-15.7.875-2.062-3.391 1.622-9.284 8.233-13.161 5.732-3.367 11.786-4.103 14.628-2.025"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m101.761 212.667-16.825 1.685-1.66 3.088 16.742-1.676c.6-.92 1.343-2.067 1.743-3.097Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M209.525 197.49c8.138-.815 11.259-7.177 6.963-14.216l-41.729-68.346c-4.295-7.032-14.375-12.072-22.512-11.258l-98.035 9.815 46.546 76.248-12.481 1.222c-10.868 1.088-23.934 9.736-29.038 19.225-2.459 4.568-2.632 8.525-.95 11.279l4.722 7.727c-1.683-2.76-1.51-6.717.949-11.285 5.105-9.483 18.17-18.137 29.038-19.225l26.056-2.609 17.447 8.727 73.024-7.311v.007Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M151.237 194.354c-2.6.261-5.823-1.328-7.17-3.529l-10.366-16.973c-1.347-2.2-.319-4.215 2.282-4.475l53.068-5.314c2.601-.26 5.823 1.329 7.171 3.529l10.365 16.974c1.347 2.2.319 4.215-2.281 4.475l-53.069 5.313Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "m95.252 109.384-20.45 37.831 14.838 24.31 35.19-65.102-29.578 2.961Zm-9.644.966-15.645 28.945 2.99 4.904 18.625-34.447-5.97.598Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    d: "M209.525 197.49c8.138-.815 11.259-7.177 6.963-14.216l-41.729-68.346c-4.295-7.032-14.375-12.072-22.512-11.258l-98.035 9.815 46.546 76.248-12.481 1.222c-10.868 1.088-23.934 9.736-29.038 19.225-2.459 4.568-2.632 8.525-.95 11.279l4.722 7.727c-1.683-2.76-1.51-6.717.949-11.285 5.105-9.483 18.17-18.137 29.038-19.225l26.056-2.609 17.447 8.727 73.024-7.311v.007Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "m160.865 181.511-3.491-1.023 1.917-1.557-1.441-1.024-1.916 1.558-1.567-2.574-1.541.154 1.575 2.58-3.484-1.023-.101 1.177 3.49 1.016-1.915 1.564 1.44 1.024 1.916-1.564 1.567 2.58 1.541-.154-1.574-2.58 3.484 1.024.1-1.178Zm14.307-1.433-3.484-1.023 1.91-1.557-1.441-1.023-1.91 1.556-1.573-2.573-1.534.153 1.567 2.581-3.484-1.023-.1 1.177 3.49 1.016-1.916 1.565 1.441 1.023 1.916-1.564 1.574 2.58 1.534-.154-1.574-2.58 3.491 1.023.093-1.177Zm14.315-1.433-3.491-1.023 1.91-1.557-1.434-1.024-1.917 1.558-1.573-2.574-1.534.154 1.574 2.58-3.491-1.023-.093 1.177 3.483 1.017-1.909 1.563 1.441 1.023 1.909-1.563 1.574 2.58 1.534-.153-1.567-2.581 3.484 1.023.1-1.177Zm66.657-145.123c3.769.787 6.661 4.549 6.458 8.403l-2.364 44.355c-.203 3.854-3.428 6.344-7.197 5.557L109.887 62.024c-3.769-.787-6.662-4.55-6.458-8.404l2.364-44.355c.203-3.854 3.428-6.343 7.197-5.556l143.147 29.815.007-.002Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "m186.289 77.938 66.737 13.903c3.77.787 6.994-1.702 7.197-5.556l2.365-44.356c.203-3.854-2.682-7.619-6.458-8.403l-26.66-5.553-43.188 49.968.007-.003Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m135.668 30.412-.234 4.294 3.751-1.399 1.596 3.496-3.753 1.392 3.529 2.906-1.929 2.756-3.526-2.9-.227 4.292-3.525-.74.227-4.29-3.75 1.398-1.604-3.493 3.76-1.394-3.529-2.907 1.929-2.756 3.529 2.907.224-4.299 3.532.737Zm24.092 5.02-.227 4.292 3.743-1.396 1.604 3.492-3.75 1.4 3.519 2.901-1.929 2.757-3.519-2.903-.227 4.292-3.532-.737.227-4.291-3.751 1.398-1.596-3.495 3.76-1.395-3.536-2.904 1.936-2.758 3.522 2.909.233-4.294 3.523.732Zm54.72 31.092-.209 3.84-18.657-3.884.202-3.837 18.664 3.88Zm-30.621-26.075-.234 4.294 3.751-1.4 1.596 3.496-3.75 1.399 3.526 2.9-1.929 2.756-3.526-2.9-.227 4.292-3.522-.733.224-4.298-3.751 1.399-1.603-3.493 3.76-1.395-3.529-2.906 1.929-2.757 3.529 2.907.226-4.291 3.53.73Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "M260.855 30.397 117.711.588c-1.734-.356-3.352-.031-4.609.808l-4.713 3.119c1.259-.833 2.875-1.165 4.608-.809l143.147 29.816c3.769.787 6.661 4.549 6.458 8.403l-2.364 44.355c-.107 2.088-1.107 3.773-2.593 4.758l4.714-3.118c1.486-.985 2.479-2.667 2.593-4.758l2.364-44.355c.203-3.854-2.682-7.619-6.458-8.403l-.003-.007Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m264.219 32.052-4.714 3.118a8.736 8.736 0 0 1 2.231 2.808l4.713-3.118a8.746 8.746 0 0 0-2.23-2.808Zm3.087 6.75a8.099 8.099 0 0 0-.114-1.722l-4.713 3.118c.105.566.15 1.145.113 1.722l-2.364 44.356c-.107 2.088-1.107 3.772-2.593 4.758l4.714-3.119c1.486-.985 2.479-2.667 2.592-4.757l2.365-44.356Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.284,
    d: "M260.855 30.397 117.711.588c-1.734-.356-3.352-.031-4.609.808l-4.713 3.119c1.259-.833 2.875-1.165 4.608-.809l143.147 29.816c3.769.787 6.661 4.549 6.458 8.403l-2.364 44.355c-.107 2.088-1.107 3.773-2.593 4.758l4.714-3.118c1.486-.985 2.479-2.667 2.593-4.758l2.364-44.355c.203-3.854-2.682-7.619-6.458-8.403l-.003-.007Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.284,
    d: "M256.144 33.522c3.769.787 6.661 4.549 6.458 8.403l-2.364 44.355c-.203 3.854-3.428 6.344-7.197 5.557L109.887 62.024c-3.769-.787-6.662-4.55-6.458-8.404l2.364-44.355c.203-3.854 3.428-6.343 7.197-5.556l143.147 29.815.007-.002Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "m103.043 136.338 143.147 29.816c1.733.356 3.351.031 4.608-.808l4.714-3.118c-1.26.832-2.875 1.164-4.609.808l-143.15-29.823c-3.769-.787-6.661-4.549-6.458-8.403l2.365-44.355c.106-2.088 1.106-3.773 2.593-4.758l-4.714 3.118c-1.486.985-2.48 2.668-2.593 4.758l-2.364 44.355c-.203 3.854 2.682 7.619 6.458 8.403l.003.007Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m99.679 134.683 4.713-3.118a8.731 8.731 0 0 1-2.23-2.808l-4.714 3.118a8.73 8.73 0 0 0 2.23 2.808Zm-3.094-6.747a8.098 8.098 0 0 0 .113 1.723l4.714-3.118a7.058 7.058 0 0 1-.114-1.723l2.362-44.363c.107-2.087 1.107-3.772 2.593-4.757l-4.714 3.118c-1.486.985-2.479 2.667-2.593 4.757l-2.364 44.356.003.007Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.284,
    d: "m103.043 136.338 143.147 29.816c1.733.356 3.351.031 4.608-.808l4.714-3.118c-1.26.832-2.875 1.164-4.609.808l-143.15-29.823c-3.769-.787-6.661-4.549-6.458-8.403l2.365-44.355c.106-2.088 1.106-3.773 2.593-4.758l-4.714 3.118c-1.486.985-2.48 2.668-2.593 4.758l-2.364 44.355c-.203 3.854 2.682 7.619 6.458 8.403l.003.007Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    d: "M254.011 104.712 110.864 74.896c-1.734-.356-3.351-.03-4.609.809l-4.713 3.118c1.26-.833 2.875-1.165 4.608-.809l143.147 29.816c3.77.787 6.662 4.549 6.459 8.403l-2.365 44.355c-.106 2.088-1.107 3.773-2.593 4.758l4.714-3.118c1.486-.985 2.479-2.667 2.593-4.758l2.364-44.355c.203-3.854-2.682-7.619-6.458-8.403Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m257.375 106.366-4.714 3.118a8.745 8.745 0 0 1 2.231 2.808l4.713-3.118a8.756 8.756 0 0 0-2.23-2.808Zm3.084 6.744a8.1 8.1 0 0 0-.113-1.723l-4.714 3.118c.105.566.15 1.146.114 1.723l-2.365 44.355c-.106 2.088-1.106 3.773-2.592 4.758l4.713-3.118c1.486-.985 2.479-2.668 2.593-4.758l2.364-44.355Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.284,
    d: "M254.011 104.712 110.864 74.896c-1.734-.356-3.351-.03-4.609.809l-4.713 3.118c1.26-.833 2.875-1.165 4.608-.809l143.147 29.816c3.77.787 6.662 4.549 6.459 8.403l-2.365 44.355c-.106 2.088-1.107 3.773-2.593 4.758l4.714-3.118c1.486-.985 2.479-2.667 2.593-4.758l2.364-44.355c.203-3.854-2.682-7.619-6.458-8.403Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.284,
    d: "M249.297 107.83c3.77.787 6.662 4.549 6.459 8.403l-2.365 44.355c-.203 3.854-3.427 6.344-7.197 5.557l-143.151-29.806c-3.77-.787-6.662-4.549-6.459-8.404l2.372-44.358c.203-3.854 3.428-6.343 7.197-5.556L249.3 107.837l-.003-.007Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M190.606 109.394a26.496 26.496 0 0 1 4.35-1.939c.776-.262 1.068-1.241.652-2.188-.416-.947-1.381-1.499-2.148-1.232a28.36 28.36 0 0 0-4.732 2.108c-8.11 4.533-13.527 12.772-15.255 23.194-1.172 7.061-.566 14.621 1.693 22.017l3.366.702c-2.364-7.153-3.055-14.508-1.921-21.365 1.585-9.567 6.564-17.134 14.002-21.299l-.007.002Zm34.776 38.363-4.132-7.124c-3.846-6.638-11.226-9.659-16.447-6.732-5.224 2.92-6.347 10.702-2.503 17.332l3.729 6.434.076.139 3.743.781c-.39-.79-.811-1.576-1.261-2.353l-3.73-6.433c-2.807-4.841-1.985-10.514 1.824-12.648 3.809-2.135 9.197.074 12.005 4.915l4.131 7.124a65.852 65.852 0 0 1 5.872 13.316l3.329.69a70.578 70.578 0 0 0-6.639-15.448l.003.007Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "m230.844 144.696-4.132-7.123c-6.064-10.459-17.697-15.222-25.935-10.619-8.236 4.61-10.01 16.867-3.946 27.326l1.042 1.804 3.856.803-2.34-4.039c-5.022-8.672-3.557-18.824 3.266-22.642 6.823-3.818 16.462.125 21.49 8.794l4.132 7.124a75.409 75.409 0 0 1 7.507 17.854l3.285.682c-1.765-6.827-4.521-13.577-8.228-19.971l.003.007Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M189.709 138.552c.445-5.664 2.757-10.504 6.516-13.622.625-.518.637-1.618.022-2.447-.617-.835-1.624-1.086-2.249-.568-4.297 3.564-6.949 9.098-7.458 15.572-.434 5.541.745 11.442 3.323 16.929l3.69.768c-2.895-5.294-4.266-11.166-3.837-16.635l-.007.003Zm52.098 18.32c-.815.157-1.212 1.07-.887 2.034a83.593 83.593 0 0 1 1.868 6.536l3.288.689a88.445 88.445 0 0 0-2.201-7.783c-.328-.971-1.25-1.626-2.068-1.476Zm-9.629-22.353c-4.248-7.328-10.789-12.969-17.945-15.474-.874-.307-1.655.203-1.739 1.131-.084.928.557 1.937 1.431 2.244 6.256 2.192 11.976 7.126 15.688 13.534l4.132 7.123a88.238 88.238 0 0 1 4.26 8.341c.423.945 1.385 1.49 2.159 1.221a.944.944 0 0 0 .187-.083c.63-.353.837-1.253.452-2.116a93.458 93.458 0 0 0-4.486-8.8l-4.132-7.124-.007.003Zm-25.229-16.885c-2.49-.085-4.893.259-7.123 1.026-.776.262-1.066 1.248-.652 2.188.416.947 1.381 1.499 2.155 1.23 1.951-.667 4.048-.965 6.225-.895.239.01.46-.046.64-.15.476-.266.737-.868.621-1.573-.162-.982-1-1.802-1.859-1.828l-.007.002Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M237.641 131.458c-10.497-18.11-30.643-26.354-44.907-18.377-.483.268-.95.554-1.413.855-.677.441-.772 1.516-.213 2.388.558.873 1.563 1.228 2.238.78.41-.267.838-.531 1.273-.774 12.852-7.185 31.003.24 40.457 16.563l4.132 7.123c.52.902 1.52 1.307 2.222.912.71-.397.856-1.442.335-2.344l-4.131-7.124.007-.002Zm-51.205-13.23c-2.189 2.532-3.878 5.543-5.038 8.954-.279.839.158 1.929.995 2.44.513.316 1.055.337 1.454.106.256-.139.451-.375.564-.702 1.043-3.074 2.566-5.789 4.535-8.067.538-.621.412-1.744-.28-2.497-.692-.753-1.695-.863-2.232-.241l.002.007Zm-3.368 16.896c.108-.928-.51-1.939-1.384-2.269-.875-.33-1.664.159-1.774 1.081-.711 6.148.169 12.657 2.468 18.919l3.453.718c-2.48-6.071-3.459-12.456-2.766-18.456l.003.007Zm36.189-28.993c-.864-.389-1.701.014-1.867.916-.167.901.391 1.949 1.256 2.338 4.957 2.268 9.558 5.514 13.667 9.658.572.582 1.321.727 1.858.431.135-.072.257-.179.362-.312.505-.666.331-1.787-.389-2.506-4.473-4.515-9.484-8.059-14.884-10.518l-.003-.007Zm-7.268-2.567c-4.057-1.018-8.065-1.338-11.916-.952-.834.085-1.3.943-1.042 1.922.266.978 1.156 1.699 1.993 1.622 3.532-.351 7.216-.058 10.943.879.356.087.686.04.956-.104.388-.219.645-.66.653-1.227.009-.956-.708-1.907-1.582-2.126l-.005-.014Zm7.927 47.246-4.131-7.123c-1.625-2.81-4.752-4.089-6.969-2.851-2.217 1.239-2.686 4.529-1.061 7.339l3.73 6.434a46.412 46.412 0 0 1 2.427 4.818l3.496.726a51.334 51.334 0 0 0-3.359-6.979l-3.729-6.434c-.587-1.013-.416-2.21.381-2.654.804-.447 1.93.015 2.517 1.029l4.131 7.123a55.468 55.468 0 0 1 4.108 8.761l3.402.712a60.126 60.126 0 0 0-4.95-10.898l.007-.003Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.411,
    x2: 23.276,
    y1: 57.823,
    y2: 146.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 113.229,
    x2: 122.093,
    y1: 47.931,
    y2: 136.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 70.493,
    x2: 79.358,
    y1: 52.208,
    y2: 140.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 201.947,
    x2: 205.237,
    y1: 211.202,
    y2: 213.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 166.325,
    x2: 145.937,
    y1: 212.848,
    y2: 258.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 102.263,
    x2: 81.868,
    y1: 183.948,
    y2: 229.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 131.65,
    x2: 175.646,
    y1: 175.252,
    y2: 194.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.271012661a24416e118b60e0cbbd5cca.svg";
export { ForwardRef as ReactComponent };